/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** BigInt custom scalar type — serialized as a string */
  BigInt: { input: string; output: string };
  /** Date custom scalar type */
  Date: { input: string; output: string };
};

export type Attorney = {
  __typename?: 'Attorney';
  email: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
};

export type AuthProfile = {
  __typename?: 'AuthProfile';
  authId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type Conversation = {
  __typename?: 'Conversation';
  attorneyLastReadAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  expert: Expert;
  expertId: Scalars['BigInt']['output'];
  expertLastReadAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['BigInt']['output'];
  matter: Matter;
  matterId: Scalars['BigInt']['output'];
  messages: Array<Message>;
  unreadCount: Scalars['Int']['output'];
};

export type CreateMatterInput = {
  caseDescription: Scalars['String']['input'];
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  courtName?: InputMaybe<Scalars['String']['input']>;
  expertId?: InputMaybe<Scalars['BigInt']['input']>;
  keyDates?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nextDeadline?: InputMaybe<Scalars['Date']['input']>;
  title: Scalars['String']['input'];
  travelPlans?: InputMaybe<TravelPlans>;
  writtenReportNeeded?: InputMaybe<WrittenReportNeeded>;
};

export type CreateRetainerRequestInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  feeBreakdownType: RetainerFeeBreakdownType;
  feeType: RetainerFeeType;
  flatFee?: InputMaybe<Scalars['Int']['input']>;
  hourlyFee?: InputMaybe<Scalars['Int']['input']>;
  hoursRequested?: InputMaybe<Scalars['String']['input']>;
  matterExpertId: Scalars['BigInt']['input'];
  title: Scalars['String']['input'];
  workType: RetainerWorkType;
};

export type Expert = {
  __typename?: 'Expert';
  /** Legacy Rails URL for profile photo; may 404 if the expert has no uploaded avatar. */
  avatarUrl: Scalars['String']['output'];
  certifications: Array<ExpertCertification>;
  credentials: Array<ExpertCredential>;
  email: Scalars['String']['output'];
  hourlyRate?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  industries: Array<Industry>;
  licenses: Array<ExpertLicense>;
  linkedinProfileUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previouslyTestified: Scalars['Boolean']['output'];
  professionalExperience: Array<ExpertPosition>;
  professionalPrefix?: Maybe<Scalars['String']['output']>;
  professionalSuffix?: Maybe<Scalars['String']['output']>;
  professionalSummary?: Maybe<Scalars['String']['output']>;
  publications: Array<ExpertPaper>;
  specialties: Array<Specialty>;
  statesOfPractice: Array<ExpertState>;
  status: Scalars['String']['output'];
  subspecialties: Array<Specialty>;
  willingToTravel: Scalars['Boolean']['output'];
  yearsExperience?: Maybe<Scalars['String']['output']>;
};

export type ExpertCertification = {
  __typename?: 'ExpertCertification';
  board: Scalars['String']['output'];
  expirationYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type ExpertCredential = {
  __typename?: 'ExpertCredential';
  id: Scalars['BigInt']['output'];
  institution: Scalars['String']['output'];
  name: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type ExpertInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ExpertLicense = {
  __typename?: 'ExpertLicense';
  id: Scalars['BigInt']['output'];
  issuer: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ExpertPaper = {
  __typename?: 'ExpertPaper';
  id: Scalars['BigInt']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  publication: Scalars['String']['output'];
  topic: Scalars['String']['output'];
};

export enum ExpertParticipationDecision {
  Declined = 'DECLINED',
  Hired = 'HIRED',
}

export type ExpertPosition = {
  __typename?: 'ExpertPosition';
  endYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['BigInt']['output'];
  institution: Scalars['String']['output'];
  role: Scalars['String']['output'];
  startYear: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
};

export type ExpertState = {
  __typename?: 'ExpertState';
  code: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
};

export type Industry = {
  __typename?: 'Industry';
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
};

export type Matter = {
  __typename?: 'Matter';
  attorney: Attorney;
  attorneyId: Scalars['BigInt']['output'];
  caseDescription: Scalars['String']['output'];
  caseNumber?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  courtName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['BigInt']['output'];
  keyDates?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  matterExperts: Array<MatterExpert>;
  nextDeadline?: Maybe<Scalars['Date']['output']>;
  status: MatterStatus;
  title: Scalars['String']['output'];
  travelPlans?: Maybe<TravelPlans>;
  updatedAt: Scalars['Date']['output'];
  writtenReportNeeded?: Maybe<WrittenReportNeeded>;
};

export type MatterActivityEvent = {
  __typename?: 'MatterActivityEvent';
  actorId?: Maybe<Scalars['BigInt']['output']>;
  eventType: MatterActivityEventType;
  id: Scalars['BigInt']['output'];
  matterId: Scalars['BigInt']['output'];
  occurredAt: Scalars['Date']['output'];
};

export enum MatterActivityEventType {
  ExpertDeclined = 'EXPERT_DECLINED',
  ExpertHired = 'EXPERT_HIRED',
  ExpertInvited = 'EXPERT_INVITED',
  ExpertLeft = 'EXPERT_LEFT',
  ExpertRemoved = 'EXPERT_REMOVED',
  MatterClosed = 'MATTER_CLOSED',
  MatterCreated = 'MATTER_CREATED',
  MatterEdited = 'MATTER_EDITED',
  RetainerApproved = 'RETAINER_APPROVED',
  RetainerClosed = 'RETAINER_CLOSED',
  RetainerDeclined = 'RETAINER_DECLINED',
  RetainerRequested = 'RETAINER_REQUESTED',
  RetainerWorkCompleted = 'RETAINER_WORK_COMPLETED',
}

export type MatterActivityReceived = {
  __typename?: 'MatterActivityReceived';
  event: MatterActivityEvent;
};

export type MatterExpert = {
  __typename?: 'MatterExpert';
  createdAt: Scalars['Date']['output'];
  exitComment?: Maybe<Scalars['String']['output']>;
  exitReason?: Maybe<MatterExpertExitReason>;
  expert: Expert;
  expertId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  matterId: Scalars['BigInt']['output'];
  retainers: Array<Retainer>;
  status: MatterExpertStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum MatterExpertExitReason {
  ConflictOfInterest = 'CONFLICT_OF_INTEREST',
  DoesntFitExpertise = 'DOESNT_FIT_EXPERTISE',
  Other = 'OTHER',
  OutsideSpecialty = 'OUTSIDE_SPECIALTY',
  ScheduleConflict = 'SCHEDULE_CONFLICT',
}

export enum MatterExpertStatus {
  Declined = 'DECLINED',
  Hired = 'HIRED',
  Invited = 'INVITED',
  Removed = 'REMOVED',
}

export enum MatterStatus {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Inactive = 'INACTIVE',
}

export type MeExpert = {
  __typename?: 'MeExpert';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  depositionHourlyRate?: Maybe<Scalars['String']['output']>;
  examinationHourlyRate?: Maybe<Scalars['String']['output']>;
  hourlyRate?: Maybe<Scalars['String']['output']>;
  recordsReviewHourlyRate?: Maybe<Scalars['String']['output']>;
  stripeConnectAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectOnboarded: Scalars['Boolean']['output'];
  testimonyHourlyRate?: Maybe<Scalars['String']['output']>;
};

export type MeUser = {
  __typename?: 'MeUser';
  email: Scalars['String']['output'];
  expert?: Maybe<MeExpert>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  conversationId: Scalars['BigInt']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['BigInt']['output'];
  sender: AuthProfile;
  senderId: Scalars['BigInt']['output'];
};

export type MessageReceived = {
  __typename?: 'MessageReceived';
  message: Message;
};

export type Mutation = {
  __typename?: 'Mutation';
  addExpertToMatter: MatterExpert;
  closeMatter: Matter;
  closeRetainer: Retainer;
  createExpert: Expert;
  createExpertStripeOnboardingLink: Scalars['String']['output'];
  createMatter: Matter;
  createRetainerRequest: Retainer;
  declineRetainer: Retainer;
  markConversationRead: Conversation;
  markRetainerWorkActive: Retainer;
  markRetainerWorkComplete: Retainer;
  removeExpertFromMatter: MatterExpert;
  sendMessage: Message;
  startRetainerFunding: Scalars['String']['output'];
  updateExpertParticipation: MatterExpert;
  updateMatter: Matter;
};

export type MutationAddExpertToMatterArgs = {
  expertId: Scalars['BigInt']['input'];
  matterId: Scalars['BigInt']['input'];
};

export type MutationCloseMatterArgs = {
  id: Scalars['BigInt']['input'];
};

export type MutationCloseRetainerArgs = {
  closedMessage?: InputMaybe<Scalars['String']['input']>;
  retainerId: Scalars['BigInt']['input'];
};

export type MutationCreateExpertArgs = {
  input: ExpertInput;
};

export type MutationCreateMatterArgs = {
  input: CreateMatterInput;
};

export type MutationCreateRetainerRequestArgs = {
  input: CreateRetainerRequestInput;
};

export type MutationDeclineRetainerArgs = {
  declinedMessage?: InputMaybe<Scalars['String']['input']>;
  retainerId: Scalars['BigInt']['input'];
};

export type MutationMarkConversationReadArgs = {
  conversationId: Scalars['BigInt']['input'];
};

export type MutationMarkRetainerWorkActiveArgs = {
  retainerId: Scalars['BigInt']['input'];
};

export type MutationMarkRetainerWorkCompleteArgs = {
  retainerId: Scalars['BigInt']['input'];
};

export type MutationRemoveExpertFromMatterArgs = {
  exitComment?: InputMaybe<Scalars['String']['input']>;
  exitReason?: InputMaybe<MatterExpertExitReason>;
  expertId: Scalars['BigInt']['input'];
  matterId: Scalars['BigInt']['input'];
};

export type MutationSendMessageArgs = {
  content: Scalars['String']['input'];
  conversationId: Scalars['BigInt']['input'];
};

export type MutationStartRetainerFundingArgs = {
  retainerId: Scalars['BigInt']['input'];
};

export type MutationUpdateExpertParticipationArgs = {
  exitComment?: InputMaybe<Scalars['String']['input']>;
  exitReason?: InputMaybe<MatterExpertExitReason>;
  expertId: Scalars['BigInt']['input'];
  matterId: Scalars['BigInt']['input'];
  status: ExpertParticipationDecision;
};

export type MutationUpdateMatterArgs = {
  id: Scalars['BigInt']['input'];
  input: UpdateMatterInput;
};

export type Query = {
  __typename?: 'Query';
  conversation: Conversation;
  expert?: Maybe<Expert>;
  matter?: Maybe<Matter>;
  matterActivities: Array<MatterActivityEvent>;
  matterConversations: Array<Conversation>;
  matters: Array<Matter>;
  me?: Maybe<MeUser>;
  messages: Array<Message>;
  myMatterExperts: Array<Expert>;
  retainersForMatter: Array<Retainer>;
};

export type QueryConversationArgs = {
  expertId: Scalars['BigInt']['input'];
  matterId: Scalars['BigInt']['input'];
};

export type QueryExpertArgs = {
  expertId: Scalars['BigInt']['input'];
};

export type QueryMatterArgs = {
  id: Scalars['BigInt']['input'];
};

export type QueryMatterActivitiesArgs = {
  matterId: Scalars['BigInt']['input'];
};

export type QueryMatterConversationsArgs = {
  matterId: Scalars['BigInt']['input'];
};

export type QueryMessagesArgs = {
  before?: InputMaybe<Scalars['BigInt']['input']>;
  conversationId: Scalars['BigInt']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryRetainersForMatterArgs = {
  matterId: Scalars['BigInt']['input'];
};

export type Retainer = {
  __typename?: 'Retainer';
  additionalDetails?: Maybe<Scalars['String']['output']>;
  attorneyAgreedAt?: Maybe<Scalars['Date']['output']>;
  attorneyClosedAt?: Maybe<Scalars['Date']['output']>;
  closedMessage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  declinedMessage?: Maybe<Scalars['String']['output']>;
  expertAgreedAt?: Maybe<Scalars['Date']['output']>;
  expertClosedAt?: Maybe<Scalars['Date']['output']>;
  feeBreakdownType: RetainerFeeBreakdownType;
  feeType: RetainerFeeType;
  flatFee?: Maybe<Scalars['Int']['output']>;
  hourlyFee?: Maybe<Scalars['Int']['output']>;
  hoursRequested?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  matterExpert: MatterExpert;
  matterExpertId: Scalars['BigInt']['output'];
  paidAt?: Maybe<Scalars['Date']['output']>;
  platformFee: Scalars['Int']['output'];
  status: RetainerStatus;
  subtotal: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  workCompletedAt?: Maybe<Scalars['Date']['output']>;
  workType: RetainerWorkType;
};

export enum RetainerFeeBreakdownType {
  CourtAppointed = 'COURT_APPOINTED',
  PrivateRetainer = 'PRIVATE_RETAINER',
  ProBono = 'PRO_BONO',
}

export enum RetainerFeeType {
  FlatRate = 'FLAT_RATE',
  Hourly = 'HOURLY',
}

export enum RetainerStatus {
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
}

export enum RetainerWorkType {
  GenerationOfWrittenReport = 'GENERATION_OF_WRITTEN_REPORT',
  InPersonTestimony = 'IN_PERSON_TESTIMONY',
  RemoteDeposition = 'REMOTE_DEPOSITION',
  ReviewOfRecordsAndConference = 'REVIEW_OF_RECORDS_AND_CONFERENCE',
  SomethingElse = 'SOMETHING_ELSE',
}

export type Specialty = {
  __typename?: 'Specialty';
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  userEvents: UserEvent;
};

export enum TravelPlans {
  Desired = 'DESIRED',
  NotApplicable = 'NOT_APPLICABLE',
  Required = 'REQUIRED',
}

export type UpdateMatterInput = {
  caseDescription?: InputMaybe<Scalars['String']['input']>;
  caseNumber?: InputMaybe<Scalars['String']['input']>;
  courtName?: InputMaybe<Scalars['String']['input']>;
  keyDates?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nextDeadline?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<MatterStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  travelPlans?: InputMaybe<TravelPlans>;
  writtenReportNeeded?: InputMaybe<WrittenReportNeeded>;
};

export type UserEvent = MatterActivityReceived | MessageReceived;

export enum WrittenReportNeeded {
  Maybe = 'MAYBE',
  No = 'NO',
  Yes = 'YES',
}

export type SendMessageMutationVariables = Exact<{
  conversationId: Scalars['BigInt']['input'];
  content: Scalars['String']['input'];
}>;

export type SendMessageMutation = {
  __typename?: 'Mutation';
  sendMessage: {
    __typename?: 'Message';
    id: string;
    conversationId: string;
    senderId: string;
    content: string;
    createdAt: string;
    sender: { __typename?: 'AuthProfile'; id: string; email: string };
  };
};

export type MarkConversationReadMutationVariables = Exact<{
  conversationId: Scalars['BigInt']['input'];
}>;

export type MarkConversationReadMutation = {
  __typename?: 'Mutation';
  markConversationRead: {
    __typename?: 'Conversation';
    id: string;
    matterId: string;
    expertId: string;
    createdAt: string;
    attorneyLastReadAt?: string | null;
    expertLastReadAt?: string | null;
    unreadCount: number;
  };
};

export type CreateExpertStripeOnboardingLinkMutationVariables = Exact<{
  [key: string]: never;
}>;

export type CreateExpertStripeOnboardingLinkMutation = {
  __typename?: 'Mutation';
  createExpertStripeOnboardingLink: string;
};

export type CreateMatterMutationVariables = Exact<{
  input: CreateMatterInput;
}>;

export type CreateMatterMutation = {
  __typename?: 'Mutation';
  createMatter: {
    __typename?: 'Matter';
    id: string;
    title: string;
    caseDescription: string;
    caseNumber?: string | null;
    courtName?: string | null;
    location?: string | null;
    keyDates?: string | null;
    nextDeadline?: string | null;
    travelPlans?: TravelPlans | null;
    writtenReportNeeded?: WrittenReportNeeded | null;
    status: MatterStatus;
    closedAt?: string | null;
    attorneyId: string;
    createdAt: string;
    updatedAt: string;
    attorney: {
      __typename?: 'Attorney';
      id: string;
      name: string;
      email: string;
    };
    matterExperts: Array<{
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      exitReason?: MatterExpertExitReason | null;
      exitComment?: string | null;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        professionalSummary?: string | null;
        avatarUrl: string;
      };
      retainers: Array<{
        __typename?: 'Retainer';
        id: string;
        matterExpertId: string;
        status: RetainerStatus;
        title: string;
        workType: RetainerWorkType;
        feeBreakdownType: RetainerFeeBreakdownType;
        feeType: RetainerFeeType;
        flatFee?: number | null;
        hourlyFee?: number | null;
        hoursRequested?: string | null;
        additionalDetails?: string | null;
        subtotal: number;
        platformFee: number;
        total: number;
        expertAgreedAt?: string | null;
        attorneyAgreedAt?: string | null;
        declinedMessage?: string | null;
        closedMessage?: string | null;
        expertClosedAt?: string | null;
        attorneyClosedAt?: string | null;
        paidAt?: string | null;
        workCompletedAt?: string | null;
        createdAt: string;
        updatedAt: string;
        matterExpert: {
          __typename?: 'MatterExpert';
          id: string;
          expertId: string;
          status: MatterExpertStatus;
          expert: {
            __typename?: 'Expert';
            id: string;
            name: string;
            email: string;
            avatarUrl: string;
          };
        };
      }>;
    }>;
  };
};

export type UpdateMatterMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
  input: UpdateMatterInput;
}>;

export type UpdateMatterMutation = {
  __typename?: 'Mutation';
  updateMatter: {
    __typename?: 'Matter';
    id: string;
    title: string;
    caseDescription: string;
    caseNumber?: string | null;
    courtName?: string | null;
    location?: string | null;
    keyDates?: string | null;
    nextDeadline?: string | null;
    travelPlans?: TravelPlans | null;
    writtenReportNeeded?: WrittenReportNeeded | null;
    status: MatterStatus;
    closedAt?: string | null;
    attorneyId: string;
    createdAt: string;
    updatedAt: string;
    attorney: {
      __typename?: 'Attorney';
      id: string;
      name: string;
      email: string;
    };
    matterExperts: Array<{
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      exitReason?: MatterExpertExitReason | null;
      exitComment?: string | null;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        professionalSummary?: string | null;
        avatarUrl: string;
      };
      retainers: Array<{
        __typename?: 'Retainer';
        id: string;
        matterExpertId: string;
        status: RetainerStatus;
        title: string;
        workType: RetainerWorkType;
        feeBreakdownType: RetainerFeeBreakdownType;
        feeType: RetainerFeeType;
        flatFee?: number | null;
        hourlyFee?: number | null;
        hoursRequested?: string | null;
        additionalDetails?: string | null;
        subtotal: number;
        platformFee: number;
        total: number;
        expertAgreedAt?: string | null;
        attorneyAgreedAt?: string | null;
        declinedMessage?: string | null;
        closedMessage?: string | null;
        expertClosedAt?: string | null;
        attorneyClosedAt?: string | null;
        paidAt?: string | null;
        workCompletedAt?: string | null;
        createdAt: string;
        updatedAt: string;
        matterExpert: {
          __typename?: 'MatterExpert';
          id: string;
          expertId: string;
          status: MatterExpertStatus;
          expert: {
            __typename?: 'Expert';
            id: string;
            name: string;
            email: string;
            avatarUrl: string;
          };
        };
      }>;
    }>;
  };
};

export type CloseMatterMutationVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;

export type CloseMatterMutation = {
  __typename?: 'Mutation';
  closeMatter: {
    __typename?: 'Matter';
    id: string;
    title: string;
    caseDescription: string;
    caseNumber?: string | null;
    courtName?: string | null;
    location?: string | null;
    keyDates?: string | null;
    nextDeadline?: string | null;
    travelPlans?: TravelPlans | null;
    writtenReportNeeded?: WrittenReportNeeded | null;
    status: MatterStatus;
    closedAt?: string | null;
    attorneyId: string;
    createdAt: string;
    updatedAt: string;
    attorney: {
      __typename?: 'Attorney';
      id: string;
      name: string;
      email: string;
    };
    matterExperts: Array<{
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      exitReason?: MatterExpertExitReason | null;
      exitComment?: string | null;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        professionalSummary?: string | null;
        avatarUrl: string;
      };
      retainers: Array<{
        __typename?: 'Retainer';
        id: string;
        matterExpertId: string;
        status: RetainerStatus;
        title: string;
        workType: RetainerWorkType;
        feeBreakdownType: RetainerFeeBreakdownType;
        feeType: RetainerFeeType;
        flatFee?: number | null;
        hourlyFee?: number | null;
        hoursRequested?: string | null;
        additionalDetails?: string | null;
        subtotal: number;
        platformFee: number;
        total: number;
        expertAgreedAt?: string | null;
        attorneyAgreedAt?: string | null;
        declinedMessage?: string | null;
        closedMessage?: string | null;
        expertClosedAt?: string | null;
        attorneyClosedAt?: string | null;
        paidAt?: string | null;
        workCompletedAt?: string | null;
        createdAt: string;
        updatedAt: string;
        matterExpert: {
          __typename?: 'MatterExpert';
          id: string;
          expertId: string;
          status: MatterExpertStatus;
          expert: {
            __typename?: 'Expert';
            id: string;
            name: string;
            email: string;
            avatarUrl: string;
          };
        };
      }>;
    }>;
  };
};

export type AddExpertToMatterMutationVariables = Exact<{
  matterId: Scalars['BigInt']['input'];
  expertId: Scalars['BigInt']['input'];
}>;

export type AddExpertToMatterMutation = {
  __typename?: 'Mutation';
  addExpertToMatter: {
    __typename?: 'MatterExpert';
    id: string;
    expertId: string;
    matterId: string;
    status: MatterExpertStatus;
    exitReason?: MatterExpertExitReason | null;
    exitComment?: string | null;
  };
};

export type UpdateExpertParticipationMutationVariables = Exact<{
  matterId: Scalars['BigInt']['input'];
  expertId: Scalars['BigInt']['input'];
  status: ExpertParticipationDecision;
  exitReason?: InputMaybe<MatterExpertExitReason>;
  exitComment?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateExpertParticipationMutation = {
  __typename?: 'Mutation';
  updateExpertParticipation: {
    __typename?: 'MatterExpert';
    id: string;
    expertId: string;
    matterId: string;
    status: MatterExpertStatus;
    exitReason?: MatterExpertExitReason | null;
    exitComment?: string | null;
  };
};

export type RemoveExpertFromMatterMutationVariables = Exact<{
  matterId: Scalars['BigInt']['input'];
  expertId: Scalars['BigInt']['input'];
  exitReason?: InputMaybe<MatterExpertExitReason>;
  exitComment?: InputMaybe<Scalars['String']['input']>;
}>;

export type RemoveExpertFromMatterMutation = {
  __typename?: 'Mutation';
  removeExpertFromMatter: {
    __typename?: 'MatterExpert';
    id: string;
    expertId: string;
    matterId: string;
    status: MatterExpertStatus;
    exitReason?: MatterExpertExitReason | null;
    exitComment?: string | null;
  };
};

export type CreateRetainerRequestMutationVariables = Exact<{
  input: CreateRetainerRequestInput;
}>;

export type CreateRetainerRequestMutation = {
  __typename?: 'Mutation';
  createRetainerRequest: {
    __typename?: 'Retainer';
    id: string;
    matterExpertId: string;
    status: RetainerStatus;
    title: string;
    workType: RetainerWorkType;
    feeBreakdownType: RetainerFeeBreakdownType;
    feeType: RetainerFeeType;
    flatFee?: number | null;
    hourlyFee?: number | null;
    hoursRequested?: string | null;
    additionalDetails?: string | null;
    subtotal: number;
    platformFee: number;
    total: number;
    expertAgreedAt?: string | null;
    attorneyAgreedAt?: string | null;
    declinedMessage?: string | null;
    closedMessage?: string | null;
    expertClosedAt?: string | null;
    attorneyClosedAt?: string | null;
    paidAt?: string | null;
    workCompletedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    matterExpert: {
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        avatarUrl: string;
      };
    };
  };
};

export type StartRetainerFundingMutationVariables = Exact<{
  retainerId: Scalars['BigInt']['input'];
}>;

export type StartRetainerFundingMutation = {
  __typename?: 'Mutation';
  startRetainerFunding: string;
};

export type DeclineRetainerMutationVariables = Exact<{
  retainerId: Scalars['BigInt']['input'];
  declinedMessage?: InputMaybe<Scalars['String']['input']>;
}>;

export type DeclineRetainerMutation = {
  __typename?: 'Mutation';
  declineRetainer: {
    __typename?: 'Retainer';
    id: string;
    matterExpertId: string;
    status: RetainerStatus;
    title: string;
    workType: RetainerWorkType;
    feeBreakdownType: RetainerFeeBreakdownType;
    feeType: RetainerFeeType;
    flatFee?: number | null;
    hourlyFee?: number | null;
    hoursRequested?: string | null;
    additionalDetails?: string | null;
    subtotal: number;
    platformFee: number;
    total: number;
    expertAgreedAt?: string | null;
    attorneyAgreedAt?: string | null;
    declinedMessage?: string | null;
    closedMessage?: string | null;
    expertClosedAt?: string | null;
    attorneyClosedAt?: string | null;
    paidAt?: string | null;
    workCompletedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    matterExpert: {
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        avatarUrl: string;
      };
    };
  };
};

export type CloseRetainerMutationVariables = Exact<{
  retainerId: Scalars['BigInt']['input'];
  closedMessage?: InputMaybe<Scalars['String']['input']>;
}>;

export type CloseRetainerMutation = {
  __typename?: 'Mutation';
  closeRetainer: {
    __typename?: 'Retainer';
    id: string;
    matterExpertId: string;
    status: RetainerStatus;
    title: string;
    workType: RetainerWorkType;
    feeBreakdownType: RetainerFeeBreakdownType;
    feeType: RetainerFeeType;
    flatFee?: number | null;
    hourlyFee?: number | null;
    hoursRequested?: string | null;
    additionalDetails?: string | null;
    subtotal: number;
    platformFee: number;
    total: number;
    expertAgreedAt?: string | null;
    attorneyAgreedAt?: string | null;
    declinedMessage?: string | null;
    closedMessage?: string | null;
    expertClosedAt?: string | null;
    attorneyClosedAt?: string | null;
    paidAt?: string | null;
    workCompletedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    matterExpert: {
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        avatarUrl: string;
      };
    };
  };
};

export type MarkRetainerWorkCompleteMutationVariables = Exact<{
  retainerId: Scalars['BigInt']['input'];
}>;

export type MarkRetainerWorkCompleteMutation = {
  __typename?: 'Mutation';
  markRetainerWorkComplete: {
    __typename?: 'Retainer';
    id: string;
    matterExpertId: string;
    status: RetainerStatus;
    title: string;
    workType: RetainerWorkType;
    feeBreakdownType: RetainerFeeBreakdownType;
    feeType: RetainerFeeType;
    flatFee?: number | null;
    hourlyFee?: number | null;
    hoursRequested?: string | null;
    additionalDetails?: string | null;
    subtotal: number;
    platformFee: number;
    total: number;
    expertAgreedAt?: string | null;
    attorneyAgreedAt?: string | null;
    declinedMessage?: string | null;
    closedMessage?: string | null;
    expertClosedAt?: string | null;
    attorneyClosedAt?: string | null;
    paidAt?: string | null;
    workCompletedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    matterExpert: {
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        avatarUrl: string;
      };
    };
  };
};

export type MarkRetainerWorkActiveMutationVariables = Exact<{
  retainerId: Scalars['BigInt']['input'];
}>;

export type MarkRetainerWorkActiveMutation = {
  __typename?: 'Mutation';
  markRetainerWorkActive: {
    __typename?: 'Retainer';
    id: string;
    matterExpertId: string;
    status: RetainerStatus;
    title: string;
    workType: RetainerWorkType;
    feeBreakdownType: RetainerFeeBreakdownType;
    feeType: RetainerFeeType;
    flatFee?: number | null;
    hourlyFee?: number | null;
    hoursRequested?: string | null;
    additionalDetails?: string | null;
    subtotal: number;
    platformFee: number;
    total: number;
    expertAgreedAt?: string | null;
    attorneyAgreedAt?: string | null;
    declinedMessage?: string | null;
    closedMessage?: string | null;
    expertClosedAt?: string | null;
    attorneyClosedAt?: string | null;
    paidAt?: string | null;
    workCompletedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    matterExpert: {
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        avatarUrl: string;
      };
    };
  };
};

export type ConversationFieldsFragment = {
  __typename?: 'Conversation';
  id: string;
  matterId: string;
  expertId: string;
  createdAt: string;
  attorneyLastReadAt?: string | null;
  expertLastReadAt?: string | null;
  unreadCount: number;
};

export type ConversationQueryVariables = Exact<{
  matterId: Scalars['BigInt']['input'];
  expertId: Scalars['BigInt']['input'];
}>;

export type ConversationQuery = {
  __typename?: 'Query';
  conversation: {
    __typename?: 'Conversation';
    id: string;
    matterId: string;
    expertId: string;
    createdAt: string;
    attorneyLastReadAt?: string | null;
    expertLastReadAt?: string | null;
    unreadCount: number;
  };
};

export type MatterConversationsQueryVariables = Exact<{
  matterId: Scalars['BigInt']['input'];
}>;

export type MatterConversationsQuery = {
  __typename?: 'Query';
  matterConversations: Array<{
    __typename?: 'Conversation';
    id: string;
    matterId: string;
    expertId: string;
    createdAt: string;
    attorneyLastReadAt?: string | null;
    expertLastReadAt?: string | null;
    unreadCount: number;
  }>;
};

export type MessagesQueryVariables = Exact<{
  conversationId: Scalars['BigInt']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['BigInt']['input']>;
}>;

export type MessagesQuery = {
  __typename?: 'Query';
  messages: Array<{
    __typename?: 'Message';
    id: string;
    conversationId: string;
    senderId: string;
    content: string;
    createdAt: string;
    sender: { __typename?: 'AuthProfile'; id: string; email: string };
  }>;
};

export type ExpertQueryVariables = Exact<{
  expertId: Scalars['BigInt']['input'];
}>;

export type ExpertQuery = {
  __typename?: 'Query';
  expert?: {
    __typename?: 'Expert';
    id: string;
    email: string;
    name: string;
    avatarUrl: string;
    status: string;
    hourlyRate?: string | null;
    linkedinProfileUrl?: string | null;
    willingToTravel: boolean;
    previouslyTestified: boolean;
    professionalSummary?: string | null;
    professionalPrefix?: string | null;
    professionalSuffix?: string | null;
    yearsExperience?: string | null;
    industries: Array<{ __typename?: 'Industry'; name: string }>;
    specialties: Array<{ __typename?: 'Specialty'; name: string }>;
    subspecialties: Array<{ __typename?: 'Specialty'; name: string }>;
    statesOfPractice: Array<{ __typename?: 'ExpertState'; name: string }>;
    credentials: Array<{
      __typename?: 'ExpertCredential';
      name: string;
      institution: string;
      year: string;
    }>;
    certifications: Array<{
      __typename?: 'ExpertCertification';
      name: string;
      board: string;
      year: number;
      expirationYear?: number | null;
    }>;
    licenses: Array<{
      __typename?: 'ExpertLicense';
      name: string;
      issuer: string;
      number: string;
      status: string;
    }>;
    professionalExperience: Array<{
      __typename?: 'ExpertPosition';
      role: string;
      institution: string;
      startYear: number;
      endYear?: number | null;
      summary: string;
    }>;
    publications: Array<{
      __typename?: 'ExpertPaper';
      publication: string;
      topic: string;
      publicUrl?: string | null;
    }>;
  } | null;
};

export type MatterActivitiesQueryVariables = Exact<{
  matterId: Scalars['BigInt']['input'];
}>;

export type MatterActivitiesQuery = {
  __typename?: 'Query';
  matterActivities: Array<{
    __typename?: 'MatterActivityEvent';
    id: string;
    matterId: string;
    eventType: MatterActivityEventType;
    actorId?: string | null;
    occurredAt: string;
  }>;
};

export type MatterFieldsFragment = {
  __typename?: 'Matter';
  id: string;
  title: string;
  caseDescription: string;
  caseNumber?: string | null;
  courtName?: string | null;
  location?: string | null;
  keyDates?: string | null;
  nextDeadline?: string | null;
  travelPlans?: TravelPlans | null;
  writtenReportNeeded?: WrittenReportNeeded | null;
  status: MatterStatus;
  closedAt?: string | null;
  attorneyId: string;
  createdAt: string;
  updatedAt: string;
  attorney: {
    __typename?: 'Attorney';
    id: string;
    name: string;
    email: string;
  };
  matterExperts: Array<{
    __typename?: 'MatterExpert';
    id: string;
    expertId: string;
    status: MatterExpertStatus;
    exitReason?: MatterExpertExitReason | null;
    exitComment?: string | null;
    expert: {
      __typename?: 'Expert';
      id: string;
      name: string;
      email: string;
      professionalSummary?: string | null;
      avatarUrl: string;
    };
    retainers: Array<{
      __typename?: 'Retainer';
      id: string;
      matterExpertId: string;
      status: RetainerStatus;
      title: string;
      workType: RetainerWorkType;
      feeBreakdownType: RetainerFeeBreakdownType;
      feeType: RetainerFeeType;
      flatFee?: number | null;
      hourlyFee?: number | null;
      hoursRequested?: string | null;
      additionalDetails?: string | null;
      subtotal: number;
      platformFee: number;
      total: number;
      expertAgreedAt?: string | null;
      attorneyAgreedAt?: string | null;
      declinedMessage?: string | null;
      closedMessage?: string | null;
      expertClosedAt?: string | null;
      attorneyClosedAt?: string | null;
      paidAt?: string | null;
      workCompletedAt?: string | null;
      createdAt: string;
      updatedAt: string;
      matterExpert: {
        __typename?: 'MatterExpert';
        id: string;
        expertId: string;
        status: MatterExpertStatus;
        expert: {
          __typename?: 'Expert';
          id: string;
          name: string;
          email: string;
          avatarUrl: string;
        };
      };
    }>;
  }>;
};

export type AttorneyFieldsFragment = {
  __typename?: 'Attorney';
  id: string;
  name: string;
  email: string;
};

export type ExpertMatterListFieldsFragment = {
  __typename?: 'Expert';
  id: string;
  name: string;
  email: string;
  professionalSummary?: string | null;
  avatarUrl: string;
};

export type MattersQueryVariables = Exact<{ [key: string]: never }>;

export type MattersQuery = {
  __typename?: 'Query';
  matters: Array<{
    __typename?: 'Matter';
    id: string;
    title: string;
    caseDescription: string;
    caseNumber?: string | null;
    courtName?: string | null;
    location?: string | null;
    keyDates?: string | null;
    nextDeadline?: string | null;
    travelPlans?: TravelPlans | null;
    writtenReportNeeded?: WrittenReportNeeded | null;
    status: MatterStatus;
    closedAt?: string | null;
    attorneyId: string;
    createdAt: string;
    updatedAt: string;
    attorney: {
      __typename?: 'Attorney';
      id: string;
      name: string;
      email: string;
    };
    matterExperts: Array<{
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      exitReason?: MatterExpertExitReason | null;
      exitComment?: string | null;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        professionalSummary?: string | null;
        avatarUrl: string;
      };
      retainers: Array<{
        __typename?: 'Retainer';
        id: string;
        matterExpertId: string;
        status: RetainerStatus;
        title: string;
        workType: RetainerWorkType;
        feeBreakdownType: RetainerFeeBreakdownType;
        feeType: RetainerFeeType;
        flatFee?: number | null;
        hourlyFee?: number | null;
        hoursRequested?: string | null;
        additionalDetails?: string | null;
        subtotal: number;
        platformFee: number;
        total: number;
        expertAgreedAt?: string | null;
        attorneyAgreedAt?: string | null;
        declinedMessage?: string | null;
        closedMessage?: string | null;
        expertClosedAt?: string | null;
        attorneyClosedAt?: string | null;
        paidAt?: string | null;
        workCompletedAt?: string | null;
        createdAt: string;
        updatedAt: string;
        matterExpert: {
          __typename?: 'MatterExpert';
          id: string;
          expertId: string;
          status: MatterExpertStatus;
          expert: {
            __typename?: 'Expert';
            id: string;
            name: string;
            email: string;
            avatarUrl: string;
          };
        };
      }>;
    }>;
  }>;
};

export type MatterDetailQueryVariables = Exact<{
  id: Scalars['BigInt']['input'];
}>;

export type MatterDetailQuery = {
  __typename?: 'Query';
  matter?: {
    __typename?: 'Matter';
    id: string;
    title: string;
    caseDescription: string;
    caseNumber?: string | null;
    courtName?: string | null;
    location?: string | null;
    keyDates?: string | null;
    nextDeadline?: string | null;
    travelPlans?: TravelPlans | null;
    writtenReportNeeded?: WrittenReportNeeded | null;
    status: MatterStatus;
    closedAt?: string | null;
    attorneyId: string;
    createdAt: string;
    updatedAt: string;
    attorney: {
      __typename?: 'Attorney';
      id: string;
      name: string;
      email: string;
    };
    matterExperts: Array<{
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      exitReason?: MatterExpertExitReason | null;
      exitComment?: string | null;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        professionalSummary?: string | null;
        avatarUrl: string;
      };
      retainers: Array<{
        __typename?: 'Retainer';
        id: string;
        matterExpertId: string;
        status: RetainerStatus;
        title: string;
        workType: RetainerWorkType;
        feeBreakdownType: RetainerFeeBreakdownType;
        feeType: RetainerFeeType;
        flatFee?: number | null;
        hourlyFee?: number | null;
        hoursRequested?: string | null;
        additionalDetails?: string | null;
        subtotal: number;
        platformFee: number;
        total: number;
        expertAgreedAt?: string | null;
        attorneyAgreedAt?: string | null;
        declinedMessage?: string | null;
        closedMessage?: string | null;
        expertClosedAt?: string | null;
        attorneyClosedAt?: string | null;
        paidAt?: string | null;
        workCompletedAt?: string | null;
        createdAt: string;
        updatedAt: string;
        matterExpert: {
          __typename?: 'MatterExpert';
          id: string;
          expertId: string;
          status: MatterExpertStatus;
          expert: {
            __typename?: 'Expert';
            id: string;
            name: string;
            email: string;
            avatarUrl: string;
          };
        };
      }>;
    }>;
  } | null;
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  me?: {
    __typename?: 'MeUser';
    id: string;
    email: string;
    name?: string | null;
    role: string;
    expert?: {
      __typename?: 'MeExpert';
      avatarUrl?: string | null;
      hourlyRate?: string | null;
      depositionHourlyRate?: string | null;
      examinationHourlyRate?: string | null;
      recordsReviewHourlyRate?: string | null;
      testimonyHourlyRate?: string | null;
      stripeConnectAccountId?: string | null;
      stripeConnectOnboarded: boolean;
    } | null;
  } | null;
};

export type MyMatterExpertsQueryVariables = Exact<{ [key: string]: never }>;

export type MyMatterExpertsQuery = {
  __typename?: 'Query';
  myMatterExperts: Array<{
    __typename?: 'Expert';
    id: string;
    name: string;
    email: string;
    avatarUrl: string;
  }>;
};

export type RetainerFieldsFragment = {
  __typename?: 'Retainer';
  id: string;
  matterExpertId: string;
  status: RetainerStatus;
  title: string;
  workType: RetainerWorkType;
  feeBreakdownType: RetainerFeeBreakdownType;
  feeType: RetainerFeeType;
  flatFee?: number | null;
  hourlyFee?: number | null;
  hoursRequested?: string | null;
  additionalDetails?: string | null;
  subtotal: number;
  platformFee: number;
  total: number;
  expertAgreedAt?: string | null;
  attorneyAgreedAt?: string | null;
  declinedMessage?: string | null;
  closedMessage?: string | null;
  expertClosedAt?: string | null;
  attorneyClosedAt?: string | null;
  paidAt?: string | null;
  workCompletedAt?: string | null;
  createdAt: string;
  updatedAt: string;
  matterExpert: {
    __typename?: 'MatterExpert';
    id: string;
    expertId: string;
    status: MatterExpertStatus;
    expert: {
      __typename?: 'Expert';
      id: string;
      name: string;
      email: string;
      avatarUrl: string;
    };
  };
};

export type RetainersForMatterQueryVariables = Exact<{
  matterId: Scalars['BigInt']['input'];
}>;

export type RetainersForMatterQuery = {
  __typename?: 'Query';
  retainersForMatter: Array<{
    __typename?: 'Retainer';
    id: string;
    matterExpertId: string;
    status: RetainerStatus;
    title: string;
    workType: RetainerWorkType;
    feeBreakdownType: RetainerFeeBreakdownType;
    feeType: RetainerFeeType;
    flatFee?: number | null;
    hourlyFee?: number | null;
    hoursRequested?: string | null;
    additionalDetails?: string | null;
    subtotal: number;
    platformFee: number;
    total: number;
    expertAgreedAt?: string | null;
    attorneyAgreedAt?: string | null;
    declinedMessage?: string | null;
    closedMessage?: string | null;
    expertClosedAt?: string | null;
    attorneyClosedAt?: string | null;
    paidAt?: string | null;
    workCompletedAt?: string | null;
    createdAt: string;
    updatedAt: string;
    matterExpert: {
      __typename?: 'MatterExpert';
      id: string;
      expertId: string;
      status: MatterExpertStatus;
      expert: {
        __typename?: 'Expert';
        id: string;
        name: string;
        email: string;
        avatarUrl: string;
      };
    };
  }>;
};

export type UserEventsSubscriptionVariables = Exact<{ [key: string]: never }>;

export type UserEventsSubscription = {
  __typename?: 'Subscription';
  userEvents:
    | {
        __typename?: 'MatterActivityReceived';
        event: {
          __typename?: 'MatterActivityEvent';
          id: string;
          matterId: string;
          eventType: MatterActivityEventType;
          actorId?: string | null;
          occurredAt: string;
        };
      }
    | {
        __typename?: 'MessageReceived';
        message: {
          __typename?: 'Message';
          id: string;
          conversationId: string;
          senderId: string;
          content: string;
          createdAt: string;
          sender: { __typename?: 'AuthProfile'; id: string; email: string };
        };
      };
};

export const ConversationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Conversation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorneyLastReadAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expertLastReadAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationFieldsFragment, unknown>;
export const AttorneyFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttorneyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attorney' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttorneyFieldsFragment, unknown>;
export const ExpertMatterListFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExpertMatterListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Expert' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalSummary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExpertMatterListFieldsFragment, unknown>;
export const RetainerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RetainerFieldsFragment, unknown>;
export const MatterFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MatterFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Matter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courtName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'travelPlans' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'writtenReportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorney' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttorneyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExperts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ExpertMatterListFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'retainers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RetainerFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttorneyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attorney' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExpertMatterListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Expert' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalSummary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MatterFieldsFragment, unknown>;
export const SendMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'content' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'content' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const MarkConversationReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkConversationRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markConversationRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Conversation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorneyLastReadAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expertLastReadAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkConversationReadMutation,
  MarkConversationReadMutationVariables
>;
export const CreateExpertStripeOnboardingLinkDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateExpertStripeOnboardingLink' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createExpertStripeOnboardingLink' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateExpertStripeOnboardingLinkMutation,
  CreateExpertStripeOnboardingLinkMutationVariables
>;
export const CreateMatterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateMatter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateMatterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMatter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MatterFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttorneyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attorney' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExpertMatterListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Expert' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalSummary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MatterFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Matter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courtName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'travelPlans' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'writtenReportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorney' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttorneyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExperts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ExpertMatterListFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'retainers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RetainerFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateMatterMutation,
  CreateMatterMutationVariables
>;
export const UpdateMatterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMatter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateMatterInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMatter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MatterFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttorneyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attorney' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExpertMatterListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Expert' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalSummary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MatterFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Matter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courtName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'travelPlans' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'writtenReportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorney' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttorneyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExperts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ExpertMatterListFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'retainers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RetainerFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMatterMutation,
  UpdateMatterMutationVariables
>;
export const CloseMatterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CloseMatter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'closeMatter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MatterFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttorneyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attorney' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExpertMatterListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Expert' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalSummary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MatterFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Matter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courtName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'travelPlans' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'writtenReportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorney' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttorneyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExperts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ExpertMatterListFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'retainers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RetainerFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CloseMatterMutation, CloseMatterMutationVariables>;
export const AddExpertToMatterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddExpertToMatter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'matterId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'expertId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addExpertToMatter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matterId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'matterId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'expertId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'expertId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddExpertToMatterMutation,
  AddExpertToMatterMutationVariables
>;
export const UpdateExpertParticipationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateExpertParticipation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'matterId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'expertId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'status' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ExpertParticipationDecision' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exitReason' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MatterExpertExitReason' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exitComment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateExpertParticipation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matterId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'matterId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'expertId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'expertId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'status' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exitReason' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'exitReason' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exitComment' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'exitComment' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateExpertParticipationMutation,
  UpdateExpertParticipationMutationVariables
>;
export const RemoveExpertFromMatterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveExpertFromMatter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'matterId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'expertId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exitReason' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MatterExpertExitReason' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exitComment' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeExpertFromMatter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matterId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'matterId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'expertId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'expertId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exitReason' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'exitReason' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'exitComment' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'exitComment' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemoveExpertFromMatterMutation,
  RemoveExpertFromMatterMutationVariables
>;
export const CreateRetainerRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRetainerRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateRetainerRequestInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRetainerRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RetainerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateRetainerRequestMutation,
  CreateRetainerRequestMutationVariables
>;
export const StartRetainerFundingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartRetainerFunding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'retainerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startRetainerFunding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'retainerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'retainerId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartRetainerFundingMutation,
  StartRetainerFundingMutationVariables
>;
export const DeclineRetainerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeclineRetainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'retainerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'declinedMessage' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'declineRetainer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'retainerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'retainerId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'declinedMessage' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'declinedMessage' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RetainerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeclineRetainerMutation,
  DeclineRetainerMutationVariables
>;
export const CloseRetainerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CloseRetainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'retainerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'closedMessage' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'closeRetainer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'retainerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'retainerId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'closedMessage' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'closedMessage' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RetainerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CloseRetainerMutation,
  CloseRetainerMutationVariables
>;
export const MarkRetainerWorkCompleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkRetainerWorkComplete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'retainerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markRetainerWorkComplete' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'retainerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'retainerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RetainerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkRetainerWorkCompleteMutation,
  MarkRetainerWorkCompleteMutationVariables
>;
export const MarkRetainerWorkActiveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkRetainerWorkActive' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'retainerId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markRetainerWorkActive' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'retainerId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'retainerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RetainerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkRetainerWorkActiveMutation,
  MarkRetainerWorkActiveMutationVariables
>;
export const ConversationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Conversation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'matterId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'expertId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'conversation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matterId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'matterId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'expertId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'expertId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Conversation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorneyLastReadAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expertLastReadAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConversationQuery, ConversationQueryVariables>;
export const MatterConversationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MatterConversations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'matterId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterConversations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matterId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'matterId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ConversationFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ConversationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Conversation' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorneyLastReadAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expertLastReadAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unreadCount' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MatterConversationsQuery,
  MatterConversationsQueryVariables
>;
export const MessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Messages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'conversationId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'limit' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'before' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'BigInt' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'conversationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'conversationId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'limit' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'before' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conversationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'senderId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessagesQuery, MessagesQueryVariables>;
export const ExpertDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Expert' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'expertId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expert' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'expertId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'expertId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hourlyRate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'linkedinProfileUrl' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'willingToTravel' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'previouslyTestified' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professionalSummary' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professionalPrefix' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professionalSuffix' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'industries' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'specialties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subspecialties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'statesOfPractice' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'yearsExperience' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credentials' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'institution' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'certifications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'board' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationYear' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuer' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'number' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'professionalExperience' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'institution' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startYear' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endYear' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'publications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publication' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'topic' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publicUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExpertQuery, ExpertQueryVariables>;
export const MatterActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MatterActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'matterId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterActivities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matterId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'matterId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'matterId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actorId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MatterActivitiesQuery,
  MatterActivitiesQueryVariables
>;
export const MattersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Matters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MatterFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttorneyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attorney' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExpertMatterListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Expert' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalSummary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MatterFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Matter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courtName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'travelPlans' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'writtenReportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorney' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttorneyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExperts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ExpertMatterListFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'retainers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RetainerFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MattersQuery, MattersQueryVariables>;
export const MatterDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MatterDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'MatterFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttorneyFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Attorney' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ExpertMatterListFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Expert' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professionalSummary' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MatterFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Matter' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseDescription' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'courtName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'location' } },
          { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nextDeadline' } },
          { kind: 'Field', name: { kind: 'Name', value: 'travelPlans' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'writtenReportNeeded' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attorney' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AttorneyFields' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExperts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'exitComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'ExpertMatterListFields' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'retainers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'RetainerFields' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MatterDetailQuery, MatterDetailQueryVariables>;
export const MeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Me' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hourlyRate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'depositionHourlyRate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examinationHourlyRate' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'recordsReviewHourlyRate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'testimonyHourlyRate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeConnectAccountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stripeConnectOnboarded' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const MyMatterExpertsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyMatterExperts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myMatterExperts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MyMatterExpertsQuery,
  MyMatterExpertsQueryVariables
>;
export const RetainersForMatterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RetainersForMatter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'matterId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigInt' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'retainersForMatter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'matterId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'matterId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RetainerFields' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RetainerFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Retainer' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'matterExpertId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeBreakdownType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'feeType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flatFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hourlyFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hoursRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'additionalDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'platformFee' } },
          { kind: 'Field', name: { kind: 'Name', value: 'total' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyAgreedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'declinedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'closedMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expertClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attorneyClosedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'paidAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'workCompletedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'matterExpert' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expertId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'expert' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'avatarUrl' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RetainersForMatterQuery,
  RetainersForMatterQueryVariables
>;
export const UserEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'subscription',
      name: { kind: 'Name', value: 'UserEvents' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userEvents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MessageReceived' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'conversationId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'senderId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sender' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'email' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MatterActivityReceived' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'event' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'matterId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'eventType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'actorId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'occurredAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserEventsSubscription,
  UserEventsSubscriptionVariables
>;
